/**
 * AddonsPlaceholderSection
 *
 * SCRUM-1284: Guide Dashboard — Add-ons Placeholder
 * Placeholder section for add-on management. Full add-on UI deferred to MVP 1.22.2.
 *
 * Schema verification (2026-03-25):
 * - experience_addons.is_mandatory: EXISTS ✓
 * - experience_addons.is_discountable: EXISTS ✓
 * - Add-on routes verified: GET, POST, PUT, DELETE /addons, PUT /addons/reorder
 * - No schema/API gaps found
 */

import React from 'react';
import { Package, Info } from 'lucide-react';

export default function AddonsPlaceholderSection() {
  return (
    <div className="bg-white rounded-lg shadow p-6" data-testid="addons-placeholder-section">
      <div className="flex items-center gap-2 mb-4">
        <Package className="h-5 w-5 text-emerald-600" />
        <h3 className="text-lg font-semibold">Add-ons</h3>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-testid="addons-coming-soon">
        <div className="flex items-start gap-3">
          <Info className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-blue-800">
              Coming in MVP 1.22.2
            </p>
            <p className="text-sm text-blue-700 mt-1">
              Add-on management is coming soon. You&apos;ll be able to create optional
              and mandatory add-ons (gear rental, permit fees, gratuity) that
              customers can select during booking.
            </p>
            <p className="text-xs text-blue-600 mt-2">
              The add-ons schema and API are already in place.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
